import React from "react";
import * as THREE from "three";
import LineElement from "./LineElement";

const HOLE_OUTLINE_WIDTH = 4;
const HOLE_FACE_STROKE = "#2C3038";
const HOLE_RING_THICKNESS_MM = 1.2;

const Hole = ({
                  reaOnly,
                  data,
                  hoveredHole,
                  hoveredSideHole,
                  setSelectedHole,
                  setHoveredHole,
                  processingHandle,
                  side,
                  scale = 1,
              }) => {
    const isHovered = hoveredHole?.id === data.id || hoveredSideHole?.id === data.id
    const radius = Number(data.radius) || 0
    const dashUnit = scale > 0 ? 0.05 / scale : 0.05
    const isDashed = data.border === "dash"
    const outlinePoints = radius > 0
        ? new THREE.EllipseCurve(0, 0, radius, radius, 0, Math.PI * 2, false).getPoints(72)
        : []
    const ringInner = Math.max(radius - HOLE_RING_THICKNESS_MM, radius * 0.7, 0.05)
    const fillRadius = Math.max(ringInner * 0.92, 0.05)
    const showFill = Boolean(data.showFill)

    const onclickHoleHandle = () => {
        processingHandle("editHole", data.id)
        setSelectedHole(data.id)
    }
    return (
        <mesh
            renderOrder={10}
            onClick={(event) => !reaOnly && (event.stopPropagation(), onclickHoleHandle())}
            onPointerOver={(event) => !reaOnly && (event.stopPropagation(), setHoveredHole(`${data.id}${data.name}`))}
            onPointerOut={(event) => !reaOnly && (event.stopPropagation(), setHoveredHole(null))}
            position={[data.x, data.y, data.z]}>

            {isHovered && <circleGeometry args={[radius + Math.max(3, radius * 0.35)]}/>}
            <meshBasicMaterial
                toneMapped={false}
                color={"#D7E8FA"}
                depthTest={false}
                transparent
                opacity={isHovered ? 0.35 : 0}/>
            {radius > 0 && (
                <mesh renderOrder={11}>
                    <ringGeometry args={[ringInner, radius, 48]}/>
                    <meshBasicMaterial
                        color={HOLE_FACE_STROKE}
                        side={THREE.DoubleSide}
                        depthTest={false}
                    />
                </mesh>
            )}
            {showFill && fillRadius > 0 && (
                <mesh renderOrder={9}>
                    <circleGeometry args={[fillRadius]}/>
                    <meshBasicMaterial
                        color={data.color}
                        toneMapped={false}
                        depthTest={false}
                    />
                </mesh>
            )}
            {radius > 0 && outlinePoints.length > 0 && (
                <LineElement
                    width={HOLE_OUTLINE_WIDTH}
                    points={outlinePoints}
                    color={HOLE_FACE_STROKE}
                    dashSize={isDashed ? dashUnit : 0}
                    gapSize={isDashed ? dashUnit : 0}
                />
            )}
        </mesh>
    )
}
export default Hole
